export default __webpack_public_path__ + "static/signature-image-06d4a4396eb09ca3d3d7e148f37502d5.jpg";